/*
 * @Author: Teemo Ding
 * @Date: 2022-03-09 10:33:36
 * @LastEditTime: 2022-06-13 15:50:59
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/Template/MiniProgramSubscribeMessage/index.tsx
 */
import {
  Button,
  Checkbox,
  RadioGroup,
  RadioItem,
  Select,
} from '@/src/components/Antd';
import Table from '@/src/components/Antd/Table/SizeFittingTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import { Icon } from '@/src/tools/icon';
import { Form } from 'antd';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from '../../css.module.less';
import { conditionsAll, miniProgramSubscribeMessageColumns } from '../config';

const MiniProgramSubscribeMessage = ({
  dataIndex,
  templates,
  languages,
  form,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const params: any = useParams();
  const { category } = params;
  const templatesOptions = (templates || []).map((item) => ({
    ...item,
    label: (
      <div>
        <span> {item.title}</span> | <span> {item.templateId}</span>
      </div>
    ),
  }));

  const languagesAllOption = languages.map((item) => ({
    value: item.languageTag,
    label: item.description,
  }));

  const calculateLanguagesOption = (index) => {
    const selectedLanguages = (
      form.getFieldValue([
        'channelSettings',
        dataIndex,
        'mpTemplateSetting',
        'languageContents',
      ]) || []
    )
      .filter((_, oIndex) => oIndex !== index)
      .flatMap((item) => (item || {}).languages);
    const languagesOption = languagesAllOption.filter(
      (o) => !selectedLanguages.includes(o.value),
    );
    return languagesOption;
  };

  const dataSource = (variables, forAll) => {
    return forAll === false && (conditionsAll[category] || []).length
      ? variables.length
        ? (conditionsAll[category] || []).map((item) => {
            return {
              condition: item.name,
              name: variables,
            };
          })
        : []
      : variables;
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n(
        'salesChannelCommunication.index.miniProgramSubscribeMessage',
      )}>
      <Form.Item
        name={['channelSettings', dataIndex, 'enabled']}
        valuePropName='checked'>
        <Checkbox>
          {getI18n(
            'salesChannelCommunication.index.enableMiniProgramSubscribeMessageNotification',
          )}
        </Checkbox>
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) =>
          ((prevValues.channelSettings || [])[dataIndex] || {}).enabled !==
            ((curValues.channelSettings || [])[dataIndex] || {}).enabled ||
          (prevValues.channelSettings[dataIndex].mpTemplateSetting || {})
            .forAll !==
            (curValues.channelSettings[dataIndex].mpTemplateSetting || {})
              .forAll ||
          (
            ((prevValues.channelSettings || [])[dataIndex] || {})
              .mpTemplateSetting || {}
          ).mpTemplateId ==
            (
              ((curValues.channelSettings || [])[dataIndex] || {})
                .mpTemplateSetting || {}
            ).mpTemplateId
        }>
        {({ getFieldValue }: any) => {
          const defaultIndex = (
            getFieldValue([
              'channelSettings',
              dataIndex,
              'mpTemplateSetting',
              'languageContents',
            ]) || []
          ).findIndex((o) => get(o, 'setAsDefault'));
          return (
            getFieldValue(['channelSettings', dataIndex, 'enabled']) && (
              <Fragment>
                <Form.Item
                  labelCol={{ span: 24 }}
                  label={`${getI18n(
                    'salesChannelCommunication.index.selecttemplate',
                  )}*`}
                  rules={[
                    {
                      required: true,
                      message: replaceI18nVariables(
                        getI18n('general.fieldisrequired'),
                        getI18n(
                          'salesChannelCommunication.index.selecttemplate',
                        ),
                      ),
                    },
                  ]}
                  name={[
                    'channelSettings',
                    dataIndex,
                    'mpTemplateSetting',
                    'mpTemplateId',
                  ]}>
                  <SelectObjectAsValue
                    className={css.select}
                    showSearch
                    objectAsValue
                    size='large'
                    getPopupContainer={(trigger) => trigger}
                    valueKey='templateId'
                    // labelKey='name'
                    options={templatesOptions || []}
                    filterOption={(input, option) => {
                      const indexOption = templates.filter(
                        (o) => o.templateId === option.value,
                      );
                      return (
                        get(indexOption, [0, 'title'])
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  />
                </Form.Item>
                {!!(conditionsAll[category] || []).length && (
                  <Form.Item
                    name={[
                      'channelSettings',
                      dataIndex,
                      'mpTemplateSetting',
                      'forAll',
                    ]}
                    className={css.forAll}
                    initialValue={true}
                    label='Template Setting'
                    labelCol={{ span: 24 }}>
                    <RadioGroup>
                      <div className={css.radioItem}>
                        <RadioItem value={true}>
                          {getI18n(
                            'salesChannelCommunication.index.mpTemplateSettingradio1',
                          )}
                        </RadioItem>
                      </div>
                      <div className={css.radioItem}>
                        <RadioItem value={false}>
                          {getI18n(
                            'salesChannelCommunication.index.mpTemplateSettingradio2',
                          )}
                        </RadioItem>
                      </div>
                    </RadioGroup>
                  </Form.Item>
                )}
                <Form.List
                  rules={[
                    {
                      validator: async (_, values) => {
                        if (values.every((o) => !(o || {}).setAsDefault)) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'salesChannelCommunication.index.atLeast1DefaultLanguage',
                              ),
                            ),
                          );
                        } else {
                          return Promise.resolve();
                        }
                      },
                    },
                  ]}
                  name={[
                    'channelSettings',
                    dataIndex,
                    'mpTemplateSetting',
                    'languageContents',
                  ]}>
                  {(fields, { add, move, remove }, { errors }) => (
                    <div className={css.mpTemplateSetting}>
                      {fields.map((item, index) => (
                        <div
                          key={index}
                          className={css.mpTemplateSettingContain}>
                          <div className={css.languageAndDelete}>
                            <Form.Item
                              label={`${getI18n(
                                'salesChannelCommunication.index.templateLanguage',
                              )}*`}
                              labelCol={{
                                span: 24,
                              }}
                              className={css.templateLanguage}
                              rules={[
                                {
                                  required: true,
                                  message: replaceI18nVariables(
                                    getI18n('general.fieldisrequired'),
                                    getI18n(
                                      'salesChannelCommunication.index.templateLanguage',
                                    ),
                                  ),
                                },
                              ]}
                              // initialValue={calculateLanguagesOption(index)}
                              name={[fields[index].name, 'languages']}>
                              <Select
                                className={css.manualTagsSelect}
                                getPopupContainer={(trigger) => trigger}
                                mode='multiple'
                                size='large'
                                filterOption={(input, option) =>
                                  option.label
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                placeholder={getI18n(
                                  'general.advancedFilters.language.placeholder',
                                )}
                                options={calculateLanguagesOption(index)}
                                showArrow={true}
                                suffixIcon={
                                  <Icon type='iconlanguageCopy' />
                                }></Select>
                            </Form.Item>
                            {getFieldValue([
                              'channelSettings',
                              dataIndex,
                              'mpTemplateSetting',
                              'languageContents',
                            ]).length > 1 && (
                              <Button
                                className={css.deleteButton}
                                danger
                                ghost
                                onClick={() => remove(index)}>
                                {getI18n('general.delete')}
                              </Button>
                            )}
                          </div>
                          <Form.Item
                            valuePropName='checked'
                            // initialValue={calculateLanguagesOption(index)}
                            name={[fields[index].name, 'setAsDefault']}>
                            <Checkbox
                              disabled={
                                defaultIndex > -1 && defaultIndex !== index
                              }>
                              {getI18n(
                                'salesChannelCommunication.index.setAsDefaultLanguage',
                              )}
                            </Checkbox>
                          </Form.Item>
                          <div>
                            <h3>
                              {getI18n(
                                'salesChannelCommunication.index.templateInformation',
                              )}
                            </h3>
                            <p>
                              {getI18n(
                                'salesChannelCommunication.index.templateInformationcontent',
                              )}
                            </p>
                            <Table
                              id='miniProgramSubscribeMessage'
                              rowKey={(record) =>
                                record.condition || record.code
                              }
                              className={css.communicationTemplatesTable}
                              columns={miniProgramSubscribeMessageColumns(
                                getFieldValue([
                                  'channelSettings',
                                  dataIndex,
                                  'mpTemplateSetting',
                                  'forAll',
                                ]) === false &&
                                  (conditionsAll[category] || []).length,
                                fields[index].name,
                                { getI18n },
                              )}
                              dataSource={dataSource(
                                (
                                  getFieldValue([
                                    'channelSettings',
                                    dataIndex,
                                    'mpTemplateSetting',
                                    'mpTemplateId',
                                  ]) || {}
                                ).variables,
                                getFieldValue([
                                  'channelSettings',
                                  dataIndex,
                                  'mpTemplateSetting',
                                  'forAll',
                                ]),
                              )}
                              pagination={false}
                            />
                          </div>
                        </div>
                      ))}
                      <Form.ErrorList errors={errors} />
                      <Button
                        className={css.addTemplateLanguage}
                        type='primary'
                        onClick={() => add()}>
                        {getI18n(
                          'salesChannelCommunication.index.addTemplateLanguage',
                        )}
                      </Button>
                    </div>
                  )}
                </Form.List>
                {/* )}
               </Form.Item> */}
              </Fragment>
            )
          );
        }}
      </Form.Item>
    </SectionWrapper>
  );
};

export default MiniProgramSubscribeMessage;
